// extracted by mini-css-extract-plugin
export default {"qrcodeWrap":"zhiz6Iaily9O_JLJDgVD","qrcode":"YiWFlvUo1EhGZdM2R9re","pingWrap":"Huhhk1LpUs1MaXdKJf2e","common_bganimation":"hGq6hgQmHyFf_b5wvVDt"};